import React from "react";
import { Select } from "antd";

import { useConfig } from "../../../data/useConfig";
import { useFilters } from "../../../data/useFilters";

const { Option } = Select;

const DEFAULT_SORT_OPTIONS = [
  { name: "relevancia", label: "Relevância" },
  { name: "populares", label: "Mais populares" },
  { name: "novidades", label: "Novidades" },
  { name: "menor_preco", label: "Menor preço" },
  { name: "maior_preco", label: "Maior preço" },
  { name: "desconto", label: "Desconto" },
];

const SortOptions = () => {
  const { sortOptions } = useConfig();
  const { order, changeOrder } = useFilters();

  const handleChangeOrder = (value) => {
    changeOrder(value);
  };

  return (
    <Select
      defaultValue={order}
      style={{ width: 250 }}
      onChange={handleChangeOrder}
    >
      {(sortOptions || DEFAULT_SORT_OPTIONS)?.map((item) => (
        <Option value={item.name}>{item.label}</Option>
      ))}
    </Select>
  );
};

export default SortOptions;
